import { buildUrlWithParams } from '@pba/react-utils';
import { useCallback } from 'react';
import { handleAxiosError } from 'common/error-handlers';
import { useEnterEventBigMarkerMutation } from '../queries';
import { useGetTelehealthEventErrorMessage } from './useGetTelehealthEventErrorMessage';

type P = PublicParams | RequiredAuthParams;

type PublicParams = {
  baseUrl?: string;
  email?: string;
  feedback?: boolean;
  firstName: string;
  id: string;
  invitationToken?: string;
  lastName: string;
  type: 'public';
};

type RequiredAuthParams = {
  baseUrl?: string;
  feedback?: boolean;
  id: string;
  type: 'required-auth';
};

const getEnterEventBigMarkerParams = (params: P) => {
  switch (params.type) {
    case 'public':
      return {
        email: params.email,
        firstName: params.firstName,
        invitationToken: params.invitationToken,
        lastName: params.lastName,
      };
    case 'required-auth':
      return {};
  }
};

export const useOnRequestEnterEvent = () => {
  const { isPending: isJoining, mutate: enterEventBigMarker } = useEnterEventBigMarkerMutation();
  const getErrorMessage = useGetTelehealthEventErrorMessage();

  const onRequestEnterEvent = useCallback(
    (params: P) => {
      enterEventBigMarker(
        {
          ...getEnterEventBigMarkerParams(params),
          exitUri: buildUrlWithParams({
            baseUrl: params.baseUrl,
            params: params.feedback
              ? {
                  eventId: params.id,
                  feedback: true,
                }
              : {},
          }),
          id: params.id,
        },
        {
          onError(error) {
            const data = error.response?.data;
            const errorMessage = data?.type ? getErrorMessage({ type: data.type }) : undefined;

            handleAxiosError(error, errorMessage);
          },
          onSuccess(data) {
            window.open(data.enterUri, '_self');
          },
        },
      );
    },
    [enterEventBigMarker, getErrorMessage],
  );

  return { isJoining, onRequestEnterEvent };
};
